import { useMutation } from '@apollo/client';
import ADD_CONTACT_DATA_MUTATION from '../graphql/AddContactData.graphql';

const useContactData = () => {
  const [saveContactDataMutation] = useMutation(ADD_CONTACT_DATA_MUTATION);

  const saveContactData = (variables: {
    name: string;
    phoneNumber: string;
    originUrl?: string;
    source?: string;
    email?: string;
    categoryId?: number;
  }): Promise<any> => {
    return new Promise((resolve, reject) => {
      // Important: Substring some variables to match backend to prevent backend bad request
      const _variables = {
        ...variables,
        name: variables.name.substring(0, 50),
        absoluteUrl: variables.originUrl?.substring(0, 200),
      };

      saveContactDataMutation({ variables: _variables })
        .then(res => {
          if (res.data.addContactData.success) {
            resolve({ success: res.data?.addContactData.success });
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  };

  return { saveContactData };
};

export default useContactData;
